import { useEffect, useState } from "react";
import styles from "./ProjectSpend.module.css";
import axios from "axios";
import { Autocomplete, FormControl, Select, MenuItem } from "@mui/material";
import TextField from "@mui/material/TextField";
import store from "../../../Store/Store.js";
import FilterDate from "./FilterDate/FilterDate";
import { Pagination } from "antd";
import config from "../../../config/config";
import ViewTransaction from "../../Transaction/ViewTransaction/ViewTransaction";
import PreviewImage from "../../Transaction/PreviewImage/PreviewImage";
import ProjectNotification from "../ProjectNotification/ProjectNotification.js";

const ProjectSpend = () => {
  const [data, setData] = useState([]);
  const [filterInput, setFilterInput] = useState("");
  const [years, setYears] = useState([]);
  const [months, setMonths] = useState([]);
  const [selectedYear, setSelectedYear] = useState("");
  const [selectedMonth, setSelectedMonth] = useState("");
  const [selectedProject, setSelectedProject] = useState(null);
  const [invalidfilter, setinvalidfilter] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const [pageSize, setPageSize] = useState(10);
  const [project_name, setproject_name] = useState("");
  const [filteredData, setFilteredData] = useState([]);
  const [TransactionData, setTransactionData] = useState([]);
  const [currentPageData, setCurrentPageData] = useState([]);
  const [finalSelectedMonth, finalSetSelectedMonth] = useState("");
  const [finalSelectedYear, finalSetSelectedYear] = useState("");
  const [noDataForTheUser, setNoDataForTheUser] = useState(false);
  const [filteron, setFilterOn] = useState(false);
  const [category, setCategory] = useState([]);
  const [showImage, setShowImage] = useState(false);
  const [selectedImage, setSelectedImage] = useState("");
  const [imageName, setImageName] = useState("");
  const [flag, setFlag] = useState(false);
  const [OpenNotification, setOpenNotification] = useState(false);
  const [Message, setMessage] = useState(false);

  const monthNames = [
    "January",
    "February",
    "March",
    "April",
    "May",
    "June",
    "July",
    "August",
    "September",
    "October",
    "November",
    "December",
  ];

  const allProjects = {
    data: [
      { project_name: "Food", description: "Meals for employees or clients" },
      { project_name: "Fuel", description: "Fuel costs for company vehicles" },
      {
        project_name: "Office Supplies and IT",
        description: "Stationery, hardware, and IT consumables",
      },
      { project_name: "Travel", description: "General travel expenses" },
      {
        project_name: "Materials Purchase for Project/Site",
        description: "Materials for project/site work",
      },
      {
        project_name: "Subcontracting/Labor",
        description: "Payments to subcontractors",
      },
      {
        project_name: "Rent / Utility",
        description: "Office rent and utility bills",
      },
    ],
  };
  const TestProjectTransactions = {
    data: [
      {
        date: "20-03-2026 15:19:48",
        transaction_note: "this is a Note Selected before Transactions",
        user_name: "Vaibhav Srivastava",
        user_id: "d5f35a72-a0b4-4c6e-9d65-826bf3bead34",
        user_email: "vsrivastava04096@gmail.com",
        purpose: "Expense",
        transaction_note: "CUPIPayout",
        amount: 599,
        paid_to: "KLVSTC INTERNATIONAL",
        upi_id: "klvstcinternati794256.rzp@rxairtel",
        utr: "607900667523",
        transaction_id: "20260320151948303222969270",
        category_id: "NA",
        status: "processed",
        cupi_approval_status: "pending_receipt_upload",
        cupi_approval_reason: "NA",
      },
      {
        date: "10-10-2025 18:50:45",
        transaction_note: "this is a Note Selected before Transactions",
        user_name: "Vaibhav Srivastava",
        user_id: "d5f35a72-a0b4-4c6e-9d65-826bf3bead34",
        user_email: "vsrivastava04096@gmail.com",
        purpose: "Expense",
        transaction_note: "CUPIPayout",
        amount: 510,
        paid_to: "paytmqr69du4p@ptys",
        upi_id: "paytmqr69du4p@ptys",
        utr: "528318199466",
        transaction_id: "20251010185045256560595570",
        category_id: "EXP002",
        status: "processed",
        cupi_approval_status: "receipt_submitted_pending_admin_approval",
        cupi_approval_reason: "NA",
      },
      {
        date: "09-03-2026 14:24:45",
        transaction_note: "this is a Note Selected before Transactions",
        user_name: "Vaibhav Srivastava",
        user_id: "d5f35a72-a0b4-4c6e-9d65-826bf3bead34",
        user_email: "vsrivastava04096@gmail.com",
        purpose: "Expense",
        transaction_note: "CUPIPayout",
        amount: 1,
        paid_to: "PAVAN DEVATHA PRAKASH",
        upi_id: "pavan.devatha@okaxis",
        utr: "606800569000",
        transaction_id: "20260309142444300340652370",
        category_id: "NA",
        status: "processed",
        cupi_approval_status: "pending_receipt_upload",
        cupi_approval_reason: "NA",
      },
      {
        date: "09-03-2026 14:20:16",
        transaction_note: "this is a Note Selected before Transactions",
        user_name: "Vaibhav Srivastava",
        user_id: "d5f35a72-a0b4-4c6e-9d65-826bf3bead34",
        user_email: "vsrivastava04096@gmail.com",
        purpose: "Expense",
        transaction_note: "CUPIPayout",
        amount: 1,
        paid_to: "pavan.devatha@okaxis",
        upi_id: "pavan.devatha@okaxis",
        utr: "NA",
        transaction_id: "20260309141949300337537811",
        category_id: "NA",
        status: "failed",
        cupi_approval_status: "pending_receipt_upload",
        cupi_approval_reason: "NA",
      },
      {
        date: "09-03-2026 14:14:40",
        transaction_note: "this is a Note Selected before Transactions",
        user_name: "Vaibhav Srivastava",
        user_id: "d5f35a72-a0b4-4c6e-9d65-826bf3bead34",
        user_email: "vsrivastava04096@gmail.com",
        purpose: "Expense",
        transaction_note: "CUPIPayout",
        amount: 1,
        paid_to: "pavan.devatha@okaxis",
        upi_id: "pavan.devatha@okaxis",
        utr: "NA",
        transaction_id: "20260309141356300337537810",
        category_id: "NA",
        status: "failed",
        cupi_approval_status: "pending_receipt_upload",
        cupi_approval_reason: "NA",
      },
      {
        date: "09-03-2026 14:10:05",
        transaction_note: "this is a Note Selected before Transactions",
        user_name: "Vaibhav Srivastava",
        user_id: "d5f35a72-a0b4-4c6e-9d65-826bf3bead34",
        user_email: "vsrivastava04096@gmail.com",
        purpose: "Expense",
        transaction_note: "CUPIPayout",
        amount: 1,
        paid_to: "PAVAN DEVATHA PRAKASH",
        upi_id: "pavan.devatha@okaxis",
        utr: "606800568853",
        transaction_id: "20260309141005300337537870",
        category_id: "NA",
        status: "processed",
        cupi_approval_status: "pending_receipt_upload",
        cupi_approval_reason: "NA",
      },
      {
        date: "28-11-2025 16:50:56",
        transaction_note: "this is a Note Selected before Transactions",
        user_name: "Vaibhav Srivastava",
        user_id: "d5f35a72-a0b4-4c6e-9d65-826bf3bead34",
        user_email: "vsrivastava04096@gmail.com",
        purpose: "office party beer ",
        transaction_note: "CUPIPayout",
        amount: 2280,
        paid_to: "RAMADEVI VENKATAPATHI",
        upi_id: "rama12345@fbl",
        utr: "533216921704",
        transaction_id: "20251128165056271114418070",
        category_id: "NA",
        status: "processed",
        cupi_approval_status: "pending_receipt_resubmit_requested",
        cupi_approval_reason: "t4",
      },
      {
        date: "07-03-2026 14:20:05",
        transaction_note: "this is a Note Selected before Transactions",
        user_name: "Vaibhav Srivastava",
        user_id: "d5f35a72-a0b4-4c6e-9d65-826bf3bead34",
        user_email: "vsrivastava04096@gmail.com",
        purpose: "Expense",
        transaction_note: "CUPIPayout",
        amount: 1300,
        paid_to: "SWIGGY",
        upi_id: "upiswiggy@icici",
        utr: "606600555383",
        transaction_id: "20260307142005299877077570",
        category_id: "NA",
        status: "processed",
        cupi_approval_status: "pending_receipt_upload",
        cupi_approval_reason: "NA",
      },
    ],
    message: "Success",
    status: 200,
  };

  useEffect(() => {
    setData(allProjects.data);
  }, []);

  // Populate years and months
  useEffect(() => {
    const currentYear = new Date().getFullYear();
    const yearOptions = [];
    for (let year = currentYear; year >= 2025; year--) {
      yearOptions.push(year);
    }
    setYears(yearOptions);
    setMonths(monthNames);
  }, []);

  const uniqueUsers = Array.from(
    new Set(
      data.map((item) => JSON.stringify({ project_name: item.project_name })),
    ),
  ).map((item) => JSON.parse(item));

  const handleYearChange = (event) => {
    setinvalidfilter(false);
    setSelectedYear(event.target.value);
    store.setYear(event.target.value);
  };

  const handleMonthChange = (event) => {
    setinvalidfilter(false);
    setSelectedMonth(event.target.value);
    store.setMonth(event.target.value);
  };

  const handleApply = () => {
    const monthIndex =
      monthNames.findIndex((month) => month === selectedMonth) + 1;
    const formattedMonthIndex = String(monthIndex).padStart(2, "0");

    if (selectedYear === "" || selectedMonth === "" || !selectedProject) {
      setinvalidfilter(true);
      return;
    }

    setinvalidfilter(false);
    store.setSelectedMonth(selectedMonth);
    store.setSelectedYear(selectedYear);

    let tokens = localStorage.getItem("authToken");
    let parsedTokens = JSON.parse(tokens);

    // Token refresh logic can be added here if needed

    const obj = JSON.stringify({
      project_name: selectedProject.project_name,
      ledger_label: store.Company_Id,
      year: selectedYear,
      month: formattedMonthIndex,
    });

    let payload = {
      method: "post",
      maxBodyLength: Infinity,
      url: `${config.node_api_endpoint}/cupi/admin/get_cupi_company_project_transactions`, // Update endpoint if different
      headers: {
        aws_cognito_id_token: parsedTokens.IdToken,
        aws_cognito_access_token: parsedTokens.AccessToken,
        "Content-Type": "application/json",
      },
      data: obj,
    };

    // testing
    setproject_name(selectedProject.project_name.toUpperCase());
    setTransactionData(TestProjectTransactions.data);
    setFilteredData(TestProjectTransactions.data);
    axios
      .request(payload)
      .then((res) => {
        setproject_name(selectedProject.project_name.toUpperCase());
        setTransactionData(res.data.data);
        setFilteredData(res.data.data);
        setCurrentPage(1);

        if (res.data.data.length < 1) {
          setNoDataForTheUser(true);
        } else {
          setNoDataForTheUser(false);
        }
      })
      .catch((er) => {
        console.log("error-->", er);
      });

    store.setMinDate("");
    store.setMaxDate("");
    finalSetSelectedMonth(selectedMonth);
    finalSetSelectedYear(selectedYear);
  };

  // Pagination logic
  useEffect(() => {
    const startIndex = (currentPage - 1) * pageSize;
    const slicedData = filteredData.slice(startIndex, startIndex + pageSize);
    setCurrentPageData(slicedData);
  }, [filteredData, currentPage, pageSize]);

  const handlePaginationChange = (page, pageSize) => {
    setCurrentPage(page);
    setPageSize(pageSize);
  };

  const downloadCSV = () => {
    if (TransactionData.length === 0) return;

    const csvContent = generateCSV(TransactionData); // You can keep your original generateCSV function
    const blob = new Blob([csvContent], { type: "text/csv" });
    const url = URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.href = url;
    a.download = `${project_name}_${selectedYear}_${selectedMonth}.csv`;
    a.click();
    URL.revokeObjectURL(url);
  };
  const generateCSV = (data) => {
    if (!data || !data.length) return "";

    // Transform the data to replace category_id with category name
    const transformedData = data.map((item) => {
      const newItem = { ...item };
      if (newItem.category_id !== undefined) {
        const categoryData = getcategoryByCategoryId(newItem.category_id);
        delete newItem.category_id;
        newItem.category = categoryData ? categoryData.categoryName : "N/A";
        newItem.purpose =
          newItem && newItem.purpose !== "Expense" ? newItem.purpose : "N/A";
      }
      return newItem;
    });

    const headers = Object.keys(transformedData[0]).join(","); // Create the header row
    const rows = transformedData.map((obj) =>
      Object.values(obj)
        .map((value) =>
          // Handle values that might contain commas or quotes
          typeof value === "string" &&
          (value.includes(",") || value.includes('"'))
            ? `"${value.replace(/"/g, '""')}"`
            : value,
        )
        .join(","),
    ); // Map each object to a row
    return [headers, ...rows].join("\n"); // Combine headers and rows
  };
  const getcategoryByCategoryId = (categoryId) => {
    if (!category || !Array.isArray(category)) {
      return null; // Return null if category data is invalid
    }
    const foundCategory = category.find(
      (item) => item.categoryId === categoryId,
    );
    return foundCategory || null;
  };
  const getStatusConfig = (TxnStatus, status) => {
    const isProcessed = status === "processed";
    if (status == "processed") {
      switch (TxnStatus) {
        case "approved":
          return isProcessed
            ? {
                text: "SPEND APPROVED",
                image: "/Check_Icon.svg",
                className: styles.dataApproved,
              }
            : {
                text: "NA",
                image: "/na.svg",
                className: styles.dataNA,
              };
        case "pending_receipt_upload":
          return {
            text: "YET TO SUBMIT BILL",
            image: "/na.svg",
            className: styles.dataNotSubmitted,
          };
        case "rejected":
          return {
            text: "SPEND REJECTED",
            image: "/X-Icon.svg",
            className: styles.dataRejected,
          };
        case "receipt_submitted_pending_admin_approval":
          return {
            text: "BILL SUBMITTED",
            image: "/hourGlass-icon.svg",
            className: styles.dataBillSubmitted,
          };
        case "pending_receipt_resubmit_requested":
          return {
            text: "RESUBMIT BILL",
            image: "/refresh.svg",
            className: styles.dataResubmit,
          };
        default:
          return {
            text: "NA",
            image: "/na.svg",
            className: styles.dataNA,
          };
      }
    } else {
      return {
        text: "NA",
        image: "/na.svg",
        className: styles.dataNA,
      };
    }
  };
  const renderStatus = (txnStatus, status, index) => {
    let newStatus = txnStatus;
    const { text, image, className } = getStatusConfig(newStatus, status);

    return (
      <div className={className}>
        {newStatus != "cupi_approval_status" &&
          newStatus != "NA" &&
          newStatus != "pending_receipt_upload" &&
          status === "processed" && (
            <img alt={text} src={image} className={styles.btn_img} />
          )}
        <span>{text}</span>
      </div>
    );
  };
  const handleStore = (detail, category, index) => {
    console.log("---------", detail);

    store.setDate(detail.date);
    store.setDebit(detail.amount);
    store.setPaidTo(detail.paid_to);
    store.setPurpose(detail.purpose);
    store.setUPIId(detail.upi_id);
    store.setUtr(detail.utr);
    store.setTxnId(detail.transaction_id);
    store.setStatus(detail.status);
    store.setCategory(category);
    store.setTxnStatus(detail.cupi_approval_status);
    store.setIndex(index);
    store.setResubmitReason(detail.cupi_approval_reason);
    store.setNewPurpose(detail?.transaction_note);
  };
  // Keep your original generateCSV, getcategoryByCategoryId, getStatusConfig, renderStatus, handleStore functions here
  // (Copy them from the original Transaction component)

  return (
    <div className={styles.ProjectSpendContainer}>
      <div className={styles.filterContainer}>
        <div className={styles.filterOptions}>
          <Autocomplete
            disablePortal
            options={uniqueUsers}
            getOptionLabel={(option) =>
              option ? `${option.project_name}` : ""
            }
            filterOptions={(options, { inputValue }) => {
              const input = inputValue.toLowerCase();
              return options.filter((option) =>
                option.project_name.toLowerCase().includes(input),
              );
            }}
            noOptionsText={
              filterInput &&
              !uniqueUsers.some((user) =>
                user.project_name
                  .toLowerCase()
                  .includes(filterInput.toLowerCase()),
              )
                ? "Project not found"
                : "No options"
            }
            onInputChange={(event, newInputValue) => {
              setinvalidfilter(false);
              setFilterInput(newInputValue);
            }}
            onChange={(event, newValue) => {
              setinvalidfilter(false);
              if (newValue) {
                const selectedData = data.find(
                  (item) => item.project_name === newValue.project_name,
                );
                if (selectedData) {
                  setSelectedProject(selectedData);
                  setFilterInput(selectedData.project_name);
                }
              } else {
                setSelectedProject(null);
                setFilterInput("");
                setNoDataForTheUser(false);
              }
            }}
            renderInput={(params) => (
              <TextField
                {...params}
                sx={{ width: "220px", height: "56px" }}
                InputProps={{
                  ...params.InputProps,
                  style: {
                    borderRadius: "12px",
                    height: "56px",
                    border: invalidfilter ? "1px solid red" : "",
                  },
                }}
                placeholder="Search by Project Name..."
              />
            )}
            value={selectedProject}
          />

          <div className={styles.filteryear_month}>
            <FormControl>
              <Select
                value={selectedYear}
                onChange={handleYearChange}
                displayEmpty
                sx={{
                  width: "120px",
                  height: "56px",
                  border: invalidfilter ? "1px solid red" : "",
                  borderRadius: "10px",
                }}
              >
                <MenuItem value="">Year</MenuItem>
                {years.map((year) => (
                  <MenuItem key={year} value={year}>
                    {year}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>

            <FormControl>
              <Select
                value={selectedMonth}
                onChange={handleMonthChange}
                displayEmpty
                sx={{
                  width: "120px",
                  height: "56px",
                  border: invalidfilter ? "1px solid red" : "",
                  borderRadius: "10px",
                }}
              >
                <MenuItem value="">Month</MenuItem>
                {months.map((month) => (
                  <MenuItem key={month} value={month}>
                    {month}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          </div>

          <button className={styles.Button} onClick={handleApply}>
            Apply
          </button>
        </div>
      </div>

      <div className={styles.feeStatementDataTable}>
        <div className={styles.top}>
          <div className={styles.latestAccountTransactionParent}>
            <div className={styles.latestAccountTransaction}>
              <span className={styles.ChnageColor}>
                Project Transactions :{" "}
              </span>{" "}
              {project_name ? project_name.toUpperCase() : ""}
            </div>
            <div className={styles.filter}>
              <button
                className={styles.filterLinesParent}
                onClick={(e) => {
                  setFilterOn(true);
                  e.stopPropagation();
                }}
              >
                <img
                  className={styles.filterLinesIcon}
                  alt=""
                  src="/filterlines.svg"
                />
                <div className={styles.labelText2}>Filter</div>
              </button>
              {filteron && (
                <div
                  className={styles.newUsersOverlay1}
                  onClick={() => setFilterOn(false)}
                >
                  <FilterDate
                    isVisible={filteron}
                    onClose={() => setFilterOn(false)}
                    selectedMonth={finalSelectedMonth}
                    selectedYear={finalSelectedYear}
                  />
                </div>
              )}
              <button className={styles.download01Parent} onClick={downloadCSV}>
                <img
                  className={styles.filterLinesIcon}
                  alt=""
                  src="/download01.svg"
                />
                <div className={styles.labelText2}>Export</div>
              </button>
              <button className={styles.reLoadTable} onClick={handleApply}>
                <img className={styles.vectorIcon1} alt="" src="/vector7.svg" />
              </button>
            </div>
          </div>
        </div>

        <div className={styles.scrollableTableContainer}>
          <div className={styles.tableWrapper}>
            <table className={styles.table}>
              <thead className={styles.tableHead}>
                <tr className={styles.tableHeaderRowCellcontainer}>
                  <th className={styles.tableHeaderRowCell}>
                    <div className={styles.tableHeaderRowCelldiv1}>DATE</div>
                  </th>
                  <th className={styles.tableHeaderRowCell}>
                    <div className={styles.tableHeaderRowCelldiv}>PURPOSE</div>
                  </th>
                  <th className={styles.tableHeaderRowCell}>
                    <div className={styles.tableHeaderRowCelldiv}>PAID TO</div>
                  </th>
                  <th className={styles.tableHeaderRowCell}>
                    <div className={styles.tableHeaderRowCelldiv1}>
                      AMOUNT PAID
                    </div>
                  </th>
                  <th className={styles.tableHeaderRowCell}>
                    <div className={styles.tableHeaderRowCelldiv}>UPI ID</div>
                  </th>
                  <th className={styles.tableHeaderRowCell}>
                    <div className={styles.tableHeaderRowCelldiv}>UTR/RRN</div>
                  </th>
                  <th className={styles.tableHeaderRowCell}>
                    <div className={styles.tableHeaderRowCelldiv}>
                      TXN STATUS
                    </div>
                  </th>
                  <th className={styles.tableHeaderRowCell}>
                    <div className={styles.tableHeaderRowCelldiv1}>
                      APPROVAL STATUS
                    </div>
                  </th>
                  <th className={styles.tableHeaderRowCell}>
                    <div className={styles.tableHeaderRowCelldiv1}>ACTION</div>
                  </th>
                </tr>
              </thead>
              {currentPageData.length > 0 && (
                <tbody className={styles.tablebody} style={{ Padding: "20px" }}>
                  {currentPageData.map((detail, index) => (
                    <tr key={index} className={styles.tableBodyrow}>
                      <td className={styles.tableBodydata}>
                        <div className={styles.data1}>
                          {detail?.date.split(" ")[0]}
                        </div>
                      </td>
                      <td className={styles.tableBodydata}>
                        {detail?.purpose === "N/A" ||
                        detail?.purpose === "Expense" ? (
                          <div className={styles.data}>N/A</div>
                        ) : (
                          <div className={styles.data4}>
                            {detail?.purpose.slice(0, 15)}
                            {detail?.purpose.length > 15 ? "..." : ""}
                          </div>
                        )}
                      </td>
                      <td className={styles.tableBodydata}>
                        <div className={styles.data4}>
                          {detail?.paid_to.slice(0, 15)}
                          {detail?.paid_to.length > 15 ? "..." : ""}
                        </div>
                      </td>
                      <td className={styles.tableBodydatain}>
                        <div className={styles.data23}>
                          {Number(detail?.amount).toFixed(2)}
                        </div>
                      </td>
                      <td className={styles.tableBodydata}>
                        <div className={styles.data4}>{detail?.upi_id}</div>
                      </td>
                      <td className={styles.tableBodydata}>
                        <div className={styles.data2}>{detail?.utr}</div>
                      </td>
                      <td className={styles.tableBodydata}>
                        <div
                          className={
                            detail.status === "processed"
                              ? styles.tableBodydataStatusComp
                              : detail.status === "failed"
                                ? styles.tableBodydataStatusRever
                                : styles.tableBodydataStatus
                          }
                        >
                          {detail.status === "processed"
                            ? "PROCESSED"
                            : detail.status === "failed"
                              ? "REVERSED"
                              : "PROCESSING"}
                        </div>
                      </td>
                      <td className={styles.tableBodydata3}>
                        {/* Add your renderStatus function here if needed */}
                        {renderStatus(
                          detail.cupi_approval_status,
                          detail.status,
                          index,
                        )}
                      </td>
                      <td className={styles.tableBodydatabtn}>
                        <button
                          className={styles.button}
                          onClick={() => {
                            handleStore(detail, index); // Uncomment when you add handleStore
                            setFlag(true);
                          }}
                        >
                          <img
                            alt=""
                            src="/eye.svg"
                            className={styles.btn_img}
                          />
                          View More
                        </button>
                      </td>
                    </tr>
                  ))}
                </tbody>
              )}
            </table>
          </div>
        </div>

        {currentPageData.length === 0 ? (
          noDataForTheUser ? (
            <div className={styles.noHistory}>
              No transactions found for this project.
            </div>
          ) : (
            <div className={styles.noHistory}>
              Please Select the Project, Year and Month to get started.
            </div>
          )
        ) : null}

        <div
          className={
            currentPageData.length === 0 ? styles.bottom1 : styles.bottom
          }
        >
          <Pagination
            current={currentPage}
            pageSize={pageSize}
            total={filteredData.length}
            onChange={handlePaginationChange}
          />
        </div>
      </div>
      {flag && (
        <div
          className={styles.newUsersOverlay}
          onClick={() => {
            setFlag(false);
            setShowImage(false);
          }}
        >
          <ViewTransaction
            isVisible={flag}
            onClose={() => setFlag(false)}
            openImg={() => {
              setShowImage(true);
            }}
            closeImg={() => {
              setShowImage(false);
            }}
            setimg={(data) => {
              setSelectedImage(data);
            }}
            setName={(data) => {
              setImageName(data);
            }}
            setOpenSuccessPopup={() => {
              setOpenNotification(true)
              setMessage("Project Spend approved successfully")
            }}
            setOpenFailedPopup={() => {
              setOpenNotification(true)
              setMessage("Project Spend rejected successfully")
            }}
          />
          <PreviewImage
            isVisible={flag && showImage}
            CloseImg={() => {
              setShowImage(false);
            }}
            image={selectedImage}
            name={imageName}
          />
        </div>
      )}
       {OpenNotification && (
        <div className={styles.newUsersOverlay2Mid}>
          <ProjectNotification
            isVisible={OpenNotification}
            setClose={() => {
              setOpenNotification(false);
            }}
            message={Message}
          />
        </div>
      )}
    </div>
  );
};

export default ProjectSpend;
